import React from "react";
import { DeleteModal } from "../DeleteModal";
import { ReusableCardProps } from "../../types/reusableCard";

const Card: React.FC<ReusableCardProps> = ({
  title,
  subtitle,
  imageUrl,
  fallbackImageUrl = "https://placehold.co/96x96?text=No+Image",
  imageAlt = "Card Image",
  actions,
  children,
  deleteModalProps,
}) => {
  return (
    <div className="border rounded-lg p-4 shadow flex items-center justify-between gap-4">
      <div className="flex-1">
        {title && <h4 className="text-lg font-bold">{title}</h4>}
        {subtitle && (
          <div className="text-sm text-blue-600 break-all">{subtitle}</div>
        )}

        {children}

        {actions && <div className="mt-2 flex gap-2">{actions}</div>}

        {deleteModalProps?.onConfirm && <DeleteModal {...deleteModalProps} />}
      </div>

      <img
        src={imageUrl || fallbackImageUrl}
        alt={imageAlt}
        className="w-24 h-24 object-cover rounded-md"
      />
    </div>
  );
};

export default Card;
